import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { withStyles } from '@material-ui/core/styles';
import LogoutButton from '../general/LogoutButton'

const styles = theme => ({
  text:{
    fontSize: 30,
    textAlign: 'center',
    color:'#444444',
  },
})

class Result extends Component{
  render(){
    const { classes } = this.props;
    return (
      <ReactCSSTransitionGroup
        className="container result"
        component="div"
        transitionName="fade"
        transitionEnterTimeout={800}
        transitionLeaveTimeout={500}
        transitionAppear
        transitionAppearTimeout={500}
      >
        <div>
          <h3 className={classes.text}>適正試験は以上で終了となります。お疲れ様でした。</h3>
        <h3 className={classes.text}>結果は追って採用担当者からご連絡いたします。</h3>
        </div>
      </ReactCSSTransitionGroup>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Result);



// WEBPACK FOOTER //
// ./src/components/quiz/Result.js